import {isStagingAny} from '@utils/environment-helpers';
import {LxpPaths} from '@utils/lxpPaths';

/** LXP domain based on environment */
export const useLxpDomain = () => (isStagingAny ? LxpPaths.StagingLxp : '');
